import { Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { GeoConfig, GeoListItemType } from '../../configs'
import { Address } from 'depoto-core/src/entities'
import { TranslateService } from '@ngx-translate/core'
import { CompanyInfoPatch } from '../../services'

@Component({
  selector: 'address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddressFormComponent {
  private translateService = inject(TranslateService)
  @Input() address: Address | Partial<Address>
  @Output() addressChange: EventEmitter<any> = new EventEmitter()
  public states: GeoListItemType[] = []
  public countries: GeoListItemType[] = []
  public countriesWithNullOption: GeoListItemType[] = []
  public isCompanyRegisterLoading = false

  constructor() {
    this.setCountries()
    this.translateService.onLangChange.subscribe(() => this.setCountries())
  }

  private setCountries(): void {
    this.countries = GeoConfig.getCountries(this.translateService.currentLang)
    this.countriesWithNullOption = [{ name: 'all', code: '' }, ...this.countries]
  }

  public selectCountry(country: string): void {
    this.address.country = country
    switch (country) {
      case 'US':
        this.states = GeoConfig.statesUS
        break
      case 'CA':
        this.states = GeoConfig.statesCA
        break
      default:
        this.states = []
        this.address.state = ''
        break
    }
    this.addressChange.emit(this.address)
  }

  public applyCompanyInfo(patch: CompanyInfoPatch): void {
    Object.assign(this.address, patch)
    if (patch.country) {
      this.selectCountry(patch.country)
    } else {
      this.addressChange.emit(this.address)
    }
  }
}
